import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import { toast } from "react-toastify"

import './recover_password.css';
import logoPretzu from '../../assets/logos_pretzu/logo_login.svg';
import { fetchSinToken } from '../../helpers/fetch';
import { CircularProgress } from '@mui/material';

// const msgExample = 'El enlace es inválido, probablemente porque ya fue usado, por favor haz un nuevo cambio de contraseña'

export const RecoverPasswordTwo = () => {

    /* alert('---lelelele---RecoverPasswordTwo') */

    let { requestId } = useParams()
    const navigate = useNavigate()

    const [isValid, setIsValid] = useState(false)
    const [isValidMsg, setIsValidMsg] = useState('')
    const [msgError, setMsgError] = useState('')
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState({
        request_id: requestId,
        new_password: '',
        confirm_password: ''
    })

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleSave = async (e) => {
        e.preventDefault();

        const { new_password, confirm_password } = form

        if (new_password.length < 6) {
            setMsgError('Contraseña debe tener como mínimo 6 caracteres')
            return false
        }

        if (new_password === '123456' || new_password === '1234567' || new_password === '12345678' || new_password === '123456789') {
            setMsgError('Contraseña poco segura')
            return false
        }

        if (new_password === '012345' || new_password === '0123456' || new_password === '01234567' || new_password === '012345678' || new_password === '0123456789') {
            setMsgError('Contraseña poco segura')
            return false
        }

        if (new_password === '654321' || new_password === '7654321' || new_password === '87654321' || new_password === '987654321') {
            setMsgError('Contraseña poco segura')
            return false
        }

        if (new_password === '6543210' || new_password === '76543210' || new_password === '876543210' || new_password === '9876543210') {
            setMsgError('Contraseña poco segura')
            return false
        }

        if (new_password.toLocaleLowerCase() === 'abcdef' || new_password.toLocaleLowerCase() === 'abcdefg' || new_password.toLocaleLowerCase() === 'abcdefgh' || new_password.toLocaleLowerCase() === 'abcdefgi') {
            setMsgError('Contraseña poco segura')
            return false
        }

        if (new_password.toLocaleLowerCase() !== confirm_password.toLocaleLowerCase()) {
            setMsgError('Contraseñas no coinciden')
            return false
        }

        setMsgError('')
        setLoading(true)

        const resp = await fetchSinToken('recover_password/reset/password', form, 'POST');
        const body = await resp.json();

        setLoading(false)

        if (body.ok) {
            toast.success(body.msg)
            navigate('/login')
        } else {
            setMsgError(body.msg)
        }

    }

    useEffect(() => {

        const checkConfirm = async () => {

            const resp = await fetchSinToken('recover_password/reset/valida/confirm', { requestId }, 'POST');
            const body = await resp.json();

            if (body.ok) {
                setIsValid(true)
            } else {
                setIsValid(false)
                setIsValidMsg(body.msg)
            }

        }

        checkConfirm()

    }, [requestId])

    return (
        <div className='container'>
            <div className='row d-flex justify-content-center ContainerLogin'>

                <div className="col-md-5">

                    <div className="flex justify-center">
                        <img src={logoPretzu} alt="logo pretzu" />
                    </div>

                    <div className='row m-3'>
                        <div className="col text-center p-content-title-recover-password">
                            <h1 className='p-title-recover-password'>Recuperar Contraseña</h1>
                        </div>
                    </div>

                    {isValid ?
                        <NuevaClave
                            form={form}
                            handleChange={handleChange}
                            handleSave={handleSave}
                            msgError={msgError}
                            loading={loading}
                        />
                        :
                        <MsgNoValido
                            msg={isValidMsg}
                        />
                    }

                </div>
            </div>
        </div>
    )
}

const NuevaClave = ({ form, handleChange, handleSave, msgError, loading }) => {

    return (

        <>
            <div className='row m-3'>
                <div className="col text-center">
                    <h5 className='p-text-recover-password-two text-uppercase fw-bold'>Ingresa tu nueva contraseña</h5>
                </div>
            </div>

            <form className='login m-4' onSubmit={handleSave}>
                <div className="mb-4">
                    <label htmlFor="exampleInputPassword1" className="form-label">Nueva contraseña</label>
                    <input
                        type="password"
                        name="new_password"
                        className="form-control"
                        id="loginPassword"
                        placeholder="Nueva contraseña"
                        value={form.new_password || ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="exampleInputPassword1" className="form-label">Confirmar contraseña</label>
                    <input
                        type="password"
                        name="confirm_password"
                        className="form-control"
                        id="loginPassword"
                        placeholder="Confirmar contraseña"
                        value={form.confirm_password || ''}
                        onChange={handleChange}
                    />
                </div>

                <h5 style={{ fontSize: '12px', margin: '0px' }}>*Mínimo 6 caracteres</h5>

                {msgError !== '' &&
                    <h3 style={{ color: 'red', fontSize: '14px', textAlign: 'center', marginTop: '20px' }}>{msgError}</h3>
                }

                {loading ?
                    <div className='text-center'><CircularProgress color="secondary" /></div>
                    :
                    <button
                        type="submit"
                        className={(form.new_password !== '' && form.confirm_password !== '') ? 'btn' : 'btn disabled'}
                    >
                        CAMBIAR
                    </button>

                }

            </form>
        </>

    )
}

const MsgNoValido = ({ msg }) => {

    return (

        <div className='row m-3'>
            <div className="col text-center">
                <h5 className='p-text-error-confirm'>{msg}</h5>
            </div>

            <div className='text-center mt-3'>
                <Link to="/login" style={{ color: '#8E24AA', textDecoration: 'none', fontSize: '18px' }}>
                    <i class="bi bi-arrow-left-short"></i>
                    Regresar a inicio de sesión
                </Link>
            </div>
        </div>

    )
}